import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "&#230;&#179;&#168;&#230;&#132;&#143;" } }, [_c("path", { attrs: { "id": "Vector", "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M10.0007 2.49919C14.1428 2.49919 17.5006 5.85702 17.5006 9.99919C17.5006 14.1413 14.1428 17.4992 10.0007 17.4992C5.85852 17.4992 2.50065 14.1413 2.50065 9.99919C2.50065 5.85702 5.85852 2.49919 10.0007 2.49919ZM19.1673 9.99919C19.1673 4.9366 15.0632 0.83252 10.0007 0.83252C4.93804 0.83252 0.833984 4.9366 0.833984 9.99919C0.833984 15.0618 4.93804 19.1659 10.0007 19.1659C15.0632 19.1659 19.1673 15.0618 19.1673 9.99919ZM9.16732 5.41585V11.6659H10.834V5.41585H9.16732ZM10.834 12.9159H9.16407V14.5858H10.834V12.9159Z", "fill": "#FFAD66" } })])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const WarningIcon = __component__.exports;
export {
  WarningIcon as default
};
